// = Libs =
import React, { FC } from 'react';
import clsx from 'clsx';

// = Styles =
import classes from '../card.module.scss';

// = Types =
import { CardFooterProps } from './card-footer.types';

// = Components =
import Icon from '@/common/components/ui/icon/icon';

const CardFooter: FC<CardFooterProps> = (props) => {
  const { infoList = [], className = '' } = props;

  return (
    <div className={classes.card__footer}>
      <ul
        className={clsx(
          {
            [classes.card__list]: true,
          },
          className
        )}>
        {infoList?.map((item, index) => (
          <li key={`${item.title}--${index}`}>
            <Icon className={classes['card__footer-icon']} {...item} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CardFooter;
